/**
 * NotesApp_v2 Definition
 * App metadata for the unified Notes application
 */

import type { AppDefinition } from '../../types/apps';

/**
 * Canonical AppDefinition — consumed by appDefinitions.index.ts (icon
 * service, CommandPalette, AppGalleryModal, Dock Preferences, Store,
 * GlobalEntitySearch). Sole owner of entityType Note.
 */
export const NotesAppV2Definition: AppDefinition = {
  appId: 'notes-v2',
  name: 'Notes',
  version: '2.0.0',
  description: 'Quick note-taking with tags, checklists, and real-time collaboration',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Note',
    phosphorWeight: 'fill',
    color: '#f59e0b',
    metadata: {
      source: 'app',
      appId: 'notes-v2',
      isAppIcon: true,
    },
  },
  entityTypes: ['Note', 'Content.Note'],
  // Mirrors backend SEARCH_FIELD_MAP['Note'] — skeleton.content is the
  // ProseMirror plain-text export written by the websocket server's note:
  // text projector (same mechanism as Doc/Page), first 800 chars enforced
  // in compute_search_text.
  searchableSkeletonFields: {
    Note: ['content'],
  },
  component: 'NotesApp_v2',
  requiresProps: false,
  requiresEntity: false,
  isCore: true,
  entityIcons: {
    Note: {
      type: 'phosphor',
      phosphorIcon: 'Note',
      phosphorWeight: 'fill',
      color: '#f59e0b',
      metadata: {
        source: 'app',
        appId: 'notes-v2',
        entityType: 'Note',
        isAppIcon: false,
      },
    },
  },
};

export const notesAppV2Definition = {
  id: 'notes-v2',
  name: 'Notes v2',
  description: 'Quick note-taking with tags, checklists, and real-time collaboration',
  version: '2.0.0',
  
  // Entity types this app handles
  entityTypes: ['Note', 'Content.Note'],
  searchableSkeletonFields: {
    Note: ['content'], // first 800 chars enforced in compute_search_text
  },
  
  // Version requirement
  requiresVersion: 'v2',
  
  // Features
  features: {
    collaboration: true,
    aiCommands: true,
    tags: true,
    checklists: true,
    export: true,
    offline: true,
  },
  
  // UI
  icon: '📓',
  color: '#9C27B0',
  
  // Commands
  supportsCommands: [
    'entity_read',
    'entity_write',
    'entity_export',
  ],
};

export default notesAppV2Definition;

